//@flow
import { asyncComponent } from 'react-async-component'
import LoadingComponent from '../../LoadingComponent'
import ErrorComponent from '../../ErrorComponent'

export default asyncComponent({
  resolve: () => import('./Input'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncInput',
})



// WEBPACK FOOTER //
// ./src/components/QuestionElements/Input/index.js